import styled, { css } from "styled-components";
import { md, sm, xl } from "styles/breakpoint";
import { theme } from "styles/theme";

export const ProfileCardStyle = styled.div`
  & .card {
    width: 100%;
    background-color: ${(props) => props.theme.colors.black300};
    border-radius: 20px;
    display: flex;
    justify-content: space-between;

    ${xl(css`
      flex-direction: column;
    `)}

    &__avatar-wrapper {
      display: flex;
      gap: 15px;
      padding: 25px;

      ${sm(css`
        flex-direction: column;
        align-items: center;
        text-align: center;
      `)}

      .card__avatar-left {
        width: 180px;
        height: 180px;
        border-radius: 50%;
        padding: 12px;
        background: linear-gradient(
          145.92deg,
          #f59d70 4.53%,
          #7e3b32 48%,
          #f5ae8d 91.48%
        );
        .card__avatar {
          border-radius: 50%;
          position: relative;
          width: 100%;
          height: 100%;
          img {
            width: 100%;
            height: 100%;
            border-radius: inherit;
            object-fit: cover;
          }
          .avatar_input {
            position: absolute;
            inset: 0;
            cursor: pointer;
            opacity: 0;
          }
        }
      }
      .card__avatar-right {
        display: flex;
        flex-direction: column;
        width: 200px;
        justify-content: center;
        & .user_fullname {
          font-size: 24px;
          font-weight: bold;
          margin-bottom: 15px;
          word-break: break-word;
          color: ${theme.colors.yellow};
        }
        & .avatar_msg {
          font-size: 12px;
          line-height: 16px;
          color: #ccc;
          margin-bottom: 15px;
        }
        & .btn-upload:hover {
          background-color: ${(props) => props.theme.colors.white};
          color: ${(props) => props.theme.text.primary};
          opacity: 1;
        }
      }
    }
    &__info {
      max-width: 720px;
      width: 100%;
      padding: 0 25px 25px 25px;
      display: flex;
      align-items: flex-end;
      color: ${(props) => props.theme.text.white};
      font-size: 14px;
      justify-content: space-between;

      ${md(css`
        flex-direction: column;
        padding: 0;
      `)}

      &-item {
        height: 53px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;

        ${md(css`
          width: 100%;
          flex-direction: row;
          align-items: center;
          background-color: #2e2e2e;
          padding: 0 25px;
          height: 65px;
          &:not(:last-child) {
            border-bottom: 3px solid #3a3a3a;
          }
          &:last-child {
            border-radius: 0 0 20px 20px;
          }
        `)}
      }
      & .loyalty {
        cursor: pointer;
        &-title {
          margin-bottom: 5px;
          font-weight: 600;
        }
        &-inner {
          display: flex;
          gap: 10px;
          align-items: center;
          &-level {
            width: 18px;
            height: 18px;
            background-image: url("https://rajbet.com/front/img/elements/star-fill.svg");
            background-position: center;
            background-size: cover;
            white-space: nowrap;
            overflow: hidden;
            font-size: 10px;
            color: #000;
            font-weight: 700;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          &-bar {
            width: 100px;
            .ant-progress {
              &-text {
                display: none;
              }
              &-outer {
                height: 12px !important;

                margin-inline-end: unset !important;
                padding-inline-end: unset !important;
              }
              &-inner {
                background-color: rgb(202, 202, 206);
                height: 100% !important;
                .ant-progress-bg {
                  height: 100% !important;
                  background: linear-gradient(180deg, #dd3023 0%, #90241e 100%);
                }
              }
            }
          }
        }
      }
      & .loyalty-point {
        //
        &-title {
          margin-bottom: 5px;
          font-weight: 600;
        }
        &-value {
          color: ${(props) => props.theme.colors.secondary[700]};
          font-weight: bold;
          font-size: 24px;
          line-height: 32px;
          text-align: right;
        }
      }
      & .socials {
        &-id {
          span {
            font-weight: bold;
          }
        }
        &-group {
          display: flex;
          gap: 10px;
          justify-content: center;
          margin-top: 5px;
          & .btn-social {
            border-radius: 50%;
            border: 1px solid #626060;
            color: #626060;
            &.facebook:hover {
              border: 1px solid #28419c;
              color: white;
              background-color: #28419c;
              opacity: 1;
            }
            &.google:hover {
              border: 1px solid #bd0000;
              color: white;
              background-color: #bd0000;
              opacity: 1;
            }
          }
        }
      }
    }
  }
`;

export const CropImageModalOveride = css`
  & .crop-image-modal {
    & .ant-modal {
      &-content {
        height: 100%;
        background-color: ${(props) => props.theme.colors.black300};
        & .ant-modal-close {
          background-color: unset;
          color: ${(props) => props.theme.text.white};
          &:hover {
            color: ${(props) => props.theme.colors.yellow};
          }
        }
        & .ant-modal-body {
          height: 100%;
          & .btn-change-image {
            button {
              font-size: 14px;
              border-radius: 0;
              font-weight: bold;
              transition: all 0.3s;
            }
            display: flex;
            justify-content: center;
            margin: 20px 0 30px 0;
          }
        }
      }
    }
  }
`;
